<div class="files-list">
  @if (showTable) {
    <div class="row  pl-4 pr-4">
      <table class="table-borderless" style="table-layout: fixed; width: 100%;">
        <thead>
          <tr class="row">
            <th class="col-md-5">Archivo</th>
            <th class="col-md-1"></th>
          </tr>
        </thead>
        @for (file of files; track file; let i = $index) {
          <tbody>
            <tr class="row">
              <td class="text-table col-md-5">
                {{file.name}}
              </td>
              <td class="col-md-1">
                <a type="button" class="icon-table" (click)="deleteFile(i)"><i class="far fa-trash-alt"></i></a>
              </td>
            </tr>
          </tbody>
        }
      </table>
    </div>
  }
  @if (successMessage) {
    <div class="form-group">
      <div class="row">
        <div class="col-md-12">
          <ngb-alert class="mt-3" type="success" (close)="successMessage = ''">{{ successMessage }}</ngb-alert>
        </div>
      </div>
    </div>
  }
  @if (errorMessage) {
    <div class="form-group">
      <div class="row">
        <div class="col-md-12">
          <ngb-alert class="mt-3" type="danger" (close)="errorMessage = ''">{{ errorMessage }}</ngb-alert>
        </div>
      </div>
    </div>
  }
</div>
<div class="dropzone" appDropAndDrag (fileDropped)="onFileDropped($event)">
  <input [accept]="accept" type="file" #fileDropRef id="fileDropRef" multiple
    (change)="fileBrowseHandler($event.target.files)" />
  <span class="icon-upload">
    <i class="fas fa-cloud-upload-alt"></i>
  </span>
  <h3>Drag and drop</h3>
  <h3>o</h3>
  <label for="fileDropRef">Busca Archivos</label>
</div>